export default __webpack_public_path__ + "static/media/translations2.3cb083d6.png";